import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';

interface BulkButtonSelectProps {
  containerClassName?: string;
  className?: string;
  label: string;
  onChange: (value: string) => void;
  value: string;
  zIndex?: number;
  options: string[];
  labelSuffix?: string;
}

export const BulkButtonSelect = ({
  containerClassName = '',
  className = '',
  label,
  onChange,
  value,
  zIndex = undefined,
  options,
  labelSuffix = ''
}: BulkButtonSelectProps) => {
  const selectOptions: SelectOption[] = options.map((option) => ({
    key: option,
    name: labelSuffix ? `${option} ${labelSuffix}` : option,
    value: option
  }));

  const handleOnChange = (selectedOption: SelectOption) => {
    onChange(selectedOption.value);
  };

  return (
    <Select
      containerClassName={containerClassName}
      className={className}
      optionsClassName="!t-6"
      label={label}
      onChange={handleOnChange}
      options={selectOptions}
      size="small"
      value={value}
      zIndex={zIndex}
      portal
    />
  );
};
